import api from "api/api";
import { useState, useEffect, useRef } from "react";
import { AiOutlineClose } from "react-icons/ai";
import useModalStore from "zustand/zustandstore";
import { useDropzone } from "react-dropzone";
import { Backdrop } from "@mui/material";
const TemplateUpdatePro = ({
  ismodal,
  setismodal,
  cards,
  defTemplatePrompt,
  user,
  selectedTemplate,
  fetchBasicData,
  setSeverity,
  setOpen,
  setAlertMessage,
  deftemplates,
}) => {
  const [templateName, setTemplateName] = useState("");
  const [savedTemplateName, setSavedTemplateName] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [prompt, setPrompt] = useState("");
  const [modifiedvalues,setModifiedvalues]=useState([])
  const [savedprompt, setSavedPrompt] = useState("");
  const [savedPromptsMap, setSavedPromptsMap] = useState({});
  const [modifiedSectionsMap, setModifiedSectionsMap] = useState({});
  const [loading, setLoading] = useState(false);
  const [imgloading,setImgLoading]=useState(false)
  const [baseSections,setBaseSections]=useState([])
  const [showAddSection, setShowAddSection] = useState(false);
  const [newSectionName, setNewSectionName] = useState("");
  const fileInputRef = useRef(null);

  const mydata = useModalStore();
  const { getRootProps, getInputProps } = useDropzone({
    accept: { "application/pdf": [".pdf"], "image/png": [".png"], "image/jpeg": [".jpeg", ".jpg"] },
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length) {

        extractimg(acceptedFiles[0])
      }
    },
  });
  useEffect(() => {
    if (!selectedTemplate) return;

    const templateData = cards.find((card) => Object.keys(card)[0] === selectedTemplate);

    if (!templateData) return;

    const matchedTemplate = deftemplates.find((obj) => obj[selectedTemplate]);
    if (matchedTemplate) {
      const templateKey = Object.keys(templateData)[0];
      
      const promptObj = defTemplatePrompt.find((obj) => obj.template === templateKey)

      const prompt = promptObj ? promptObj.instructions : "";
      setSavedPrompt(promptObj?.prompt);
      setPrompt(prompt);
      // setTemplateName(templateKey);
      if (templateKey === "HnP") {
  setTemplateName("History & Physical");
} else if (templateKey === "soap_note") {
  setTemplateName("SOAP Note");
} else {
  setTemplateName(templateKey);
}

      setSavedTemplateName(templateKey);
      return;
    }
    const templateKeys = Object.keys(templateData)[0];
    const promptObj = defTemplatePrompt.find((obj) => obj.template === templateKeys)

    setModifiedvalues(promptObj?.sections||[])


    const matchedObj = deftemplates.find((obj) => 
      obj && obj[Object.keys(obj).find(key => key.toLowerCase() === templateData.base_template.toLowerCase())]
    );
    

    
    let keysArray = [];
    if (matchedObj) {
      const firstKey = Object.keys(matchedObj)[0]; // get the first key of the object
      const innerObj = matchedObj[firstKey];       // get the value (assumed to be an object)
      if (innerObj && typeof innerObj === 'object') {
        keysArray = Object.keys(innerObj);         // get keys of the inner object
      }
    }
    setBaseSections(keysArray||[])
    console.log(keysArray); // Final array of keys
    

    const templateKey = Object.keys(templateData)[0];
    const promptArray = templateData[templateKey].prompt || [];
    // setTemplateName(templateKey);
    if (templateKey === "HnP") {
  setTemplateName("History & Physical");
} else if (templateKey === "soap_note") {
  setTemplateName("SOAP Note");
} else {
  setTemplateName(templateKey);
}

    setSavedTemplateName(templateKey);

    const originalMap = {};
    promptArray.forEach((p) => {
      originalMap[p.section_name] = p.template_prompt;
    });
    setSavedPromptsMap(originalMap);

    if (mydata.usertype === "PRO") {
      const defaultSection = promptArray[0]?.section_name || "";
      setSelectedSection(defaultSection);
      setPrompt(originalMap[defaultSection] || "");
    } else {
      setPrompt(promptArray.join("\n"));
    }

    setModifiedSectionsMap({});
  }, [selectedTemplate, cards, mydata.usertype]);

  useEffect(() => {
    if (mydata.usertype !== "PRO" || !selectedSection) return;
    const modifiedPrompt = modifiedSectionsMap[selectedSection];
    setPrompt(modifiedPrompt || savedPromptsMap[selectedSection] || "");
  }, [selectedSection, savedPromptsMap, modifiedSectionsMap, mydata.usertype]);

  const formatSection = (section) =>
    section.toLowerCase().replace(/_/g, " ").replace(/^./, (c) => c.toUpperCase());

  const matchedTemplate = deftemplates.find((obj) => obj[selectedTemplate]);
  const matchedCard = cards.find((obj) => obj[selectedTemplate]);
  const sections = selectedTemplate
    ? matchedTemplate
      ? Object.keys(matchedTemplate[selectedTemplate])
      : matchedCard?.[selectedTemplate]?.prompt?.map((item) => item.section_name) || []
    : [];

  if (!ismodal) return null;

  const onPromptChange = (newPrompt) => {
    setPrompt(newPrompt);
    if (mydata.usertype === "PRO" && selectedSection) {
      const original = savedPromptsMap[selectedSection] || "";
      setModifiedSectionsMap((prev) => {
        if (newPrompt !== original) {
          return { ...prev, [selectedSection]: newPrompt };
        } else {
          const { [selectedSection]: _, ...rest } = prev;
          return rest;
        }
      });
    }
  };
  const onPromptedit = (newPrompt) => {
    setModifiedvalues((prev) =>
      prev.map((item) =>
        item.section_name === selectedSection
          ? { ...item, template_prompt: newPrompt }
          : item
      )
    );
  };
  const displayToKeyMap = {
  "SOAP Note": "soap_note",
  "History & Physical": "HnP",
};
  const handleSubmit = async () => {
    try {
      setLoading(true);
   const templateKey =
  displayToKeyMap[templateName] || templateName; // fallback to same if not mapped

if (templateKey !== savedTemplateName) {
  await api.put("v1/user_templates/update_template_name", {
    new_name: templateKey,
    old_name: savedTemplateName,
  });
}

      const templateData = cards.find((card) => Object.keys(card)[0] === selectedTemplate);
      const promptArray = templateData?.[selectedTemplate]?.prompt || [];

      // const fullSections = promptArray.map(({ section_name }) => ({
      //   section_name,
      //   template_prompt:
      //     modifiedSectionsMap[section_name] ?? savedPromptsMap[section_name] ?? "",
      // }));

      let payload = {};
      if (!matchedTemplate) {
        payload = {
          template_name: templateKey,
          sections: modifiedvalues,
          base_template: templateData.base_template,
        };
      } else {
        payload = {
          template_name: templateKey,
          user_instructions: prompt,
          template_prompt: savedprompt,
          default_template: true,
        };
      }

      const res = await api.post("/v1/user_templates/save_template", payload);

      if (res.status === 200) {
        setSeverity("success");
        setAlertMessage("Successfully saved the template");
        setOpen(true);
        fetchBasicData();
        setTimeout(() => {
          window.location.reload();
          setismodal(false);
        }, 1500);
      } else {
        throw new Error("Save failed");
      }
    } catch (err) {
      console.error(err);
      setSeverity("error");
      setAlertMessage("Something went wrong");
      setOpen(true);
    } finally {
         const templateKey =
  displayToKeyMap[templateName] || templateName; // fallback to same if not mapped
      setSavedTemplateName(templateKey);
      setSavedPromptsMap((prev) => {
        const copy = { ...prev };
        Object.entries(modifiedSectionsMap).forEach(([sec, edited]) => {
          copy[sec] = edited;
        });
        return copy;
      });
      setLoading(false);
    }
  };

  const extractimg = async (img) => {
    try {
   setImgLoading(true)
      const formData = new FormData();
      formData.append("file", img);
      const config = {
        headers: { "Content-Type": "multipart/form-data" },
        params: { section_name: newSectionName },
      };
      const res = await api.post(`/v1/user_templates/template_extraction`, formData, config);
      if (res.status === 200) {
        const newPrompt = res?.output || "";
        const newEntry = {
          section_name: newSectionName,
          template_prompt: newPrompt,
        };
      
        // setPrompt(newPrompt);
        setAlertMessage("Template Extraction Successful");
        setSeverity("success");
        setOpen(true);
      
        // Add to modifiedvalues
        setModifiedvalues((prev) => [...prev, newEntry]);
        setShowAddSection(false)
        setNewSectionName('')
      } else {
        throw new Error("Image extraction failed");
      }
    } catch (err) {
      console.error(err);
      setSeverity("error");
      setAlertMessage("Image extraction failed");
      setOpen(true);
    } finally {
setImgLoading(false)
    }
  };


  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center h-auto overflow-auto z-50">
      <div className="bg-white w-[90%] sm:w-[55%] h-auto flex py-4 flex-col rounded-md shadow-lg p-6 space-y-4 relative">
        <button
          className="absolute top-3 right-3 text-gray-600 hover:text-gray-900"
          onClick={() => setismodal(false)}
        >
          <AiOutlineClose size={20} />
        </button>

        <h2 className="text-xl font-semibold text-[#1c2a3a] text-left">Update Template</h2>

        <label className="text-gray-700 text-sm text-start font-medium">Template Name</label>
        <input
          type="text"
          value={templateName}
          onChange={(e) => setTemplateName(e.target.value)}
          className="border p-2 rounded-md w-full bg-gray-100"
        />

        {mydata.usertype === "PRO" && !matchedTemplate && (
          <>
            <div className="flex flex-col">
              <label className="font-medium text-sm mb-2 text-start text-[#1c2a3a]">
                Select Section
              </label>
              <select
                className="border border-gray-300 rounded-md p-2 text-sm"
                value={selectedSection}
                onChange={(e) => {
                  const newSection = e.target.value;
setSelectedSection(newSection)
                }}
              >
                <option value="">Choose Section</option>
                {modifiedvalues.map((section,index) => (
                  <option key={index} value={section.section_name
                  }>
                    {formatSection(section.section_name)}
                  </option>
                ))}
              </select>
            </div>

            <button
              onClick={() => setShowAddSection(!showAddSection)}
              className="text-sm text-blue-600 underline mt-2 text-left"
            >
              + Add Section
            </button>

            {showAddSection && (
              <div className="space-y-2 mt-2">
             <div>
             <select
  value={newSectionName}
  onChange={(e) => setNewSectionName(e.target.value)}
  className="border p-2 rounded-md w-full"
>
  <option value="" disabled>Select a section</option>
  {baseSections.map((section, index) => {
    const isDisabled = modifiedvalues.some(
      (item) => item.section_name.toLowerCase() === section.toLowerCase()
    );

    return (
      <option key={index} value={section} disabled={isDisabled}>
        {section}
      </option>
    );
  })}
</select>

    </div>
    <div
  {...getRootProps()}
  className="border border-dashed border-gray-400 p-1 rounded-md flex flex-col items-center cursor-pointer hover:bg-gray-100 transition-all"
>
  <input
    {...getInputProps()}
    disabled={!newSectionName && mydata.usertype === 'PRO'}
    accept="image/*"
  />
  <p className="text-sm text-gray-500">Drag & drop or click to upload</p>
  <button
    type="button"
    className="mt-2 px-4 py-1 bg-[#1c2a3a] text-white text-sm rounded-md"
  >
    Browse
  </button>
</div>

              </div>
            )}
          </>
        )}

        <label className="text-gray-700 text-sm text-start font-medium">Template Instruction</label>
        {mydata.usertype === "PRO" && !matchedTemplate ?<>
        
          <textarea
  value={
    modifiedvalues.find((item) => item.section_name === selectedSection)?.template_prompt || ''
  }
  rows={8}
  onChange={(e) => onPromptedit(e.target.value)}
  className="border p-2 rounded-md w-full"
/>
        </>:
        <textarea
          value={prompt}
          rows={8}
          onChange={(e) => onPromptChange(e.target.value)}
          className="border p-2 rounded-md w-full"
        />
        }
        <div className="flex justify-end space-x-4">
          <button
            onClick={() => setismodal(false)}
            className="px-4 py-2 bg-gray-300 rounded-md text-sm font-medium hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-4 py-2 cursor-pointer bg-[#1C2A3A] text-white rounded-md text-sm font-medium hover:bg-blue-700"
          >
            {loading ? "Updating…" : "Update"}
          </button>
        </div>
      </div>
         <Backdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: "rgba(0, 0, 0, 0.5)" }} open={imgloading}>
              <div className="text-white font-mono text-xl font-bold">Extracting Text...</div>
            </Backdrop>
    </div>
  );
};

export default TemplateUpdatePro;
